export default "__VITE_ASSET__BpLB_1gs__"